import Cacheable from '@src/classes/Cacheable/Cacheable';
import {ICurrencyModel} from '@src/@interfaces/models/Currency/ICurrencyModel';
import config from '@src/helpers/config';
import {PossibleCurrencies} from '@src/@types/services/Formatter/PossibleCurrencies';
import {IPriceFormatter} from '@src/@interfaces/services/Formatter/IPriceFormatter';

export default class PriceFormatter extends Cacheable implements IPriceFormatter {
    format(
        amount: number | string,
        currency?: ICurrencyModel | PossibleCurrencies | null,
        options?: Intl.NumberFormatOptions & { locale?: Intl.LocalesArgument }
    ): string {
        const {locale, ...formatterOptions} = options ?? {};

        return parseFloat(String(amount)).toLocaleString(locale, {
            style: 'currency',
            currency: this.getCurrencyAsISO4217(currency),
            minimumFractionDigits: 0,
            ...(formatterOptions ?? {}),
        });
    }

    protected getCurrencyAsISO4217(currency?: ICurrencyModel | string | null): string | undefined {
        if (!currency) {
            return config('client.defaultCurrencyCodeISO4217', undefined);
        }

        return typeof currency === 'string' ? currency : currency.codeISO4217;
    }
}
